// extracted by mini-css-extract-plugin
export default {"collapse":"CollapseArrayView_collapse__hpago"};